module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1400.4c1ff107.svg";